 export default {
  P1: "#0099A8",
  P2: "#eaf0fd",
  S1: "#CB1950",
  S2: "#FEF4E8",
  BG1: "#ffffff",
  BG2: "#f5f6fa",
  BG3: "#AAB2BD",
  G1: "#212121",
  G2: "#757575",
  G3: "#9e9e9e",
  G4: "#e0e0e0",
  G5: "#4D4D4D",
  gradientStart: "#0099A8",
  gradientEnd: "#007a8d",
};